export default "__VITE_ASSET__CpNaSXe$__"